// IndexedDB store for photos / voice clips captured while offline (localStorage is too small for media).
const DB = "tycc_offline", STORE = "photos", MAX = 5;
export const MAX_QUEUED_PHOTOS = MAX;
export const MAX_QUEUED_MEDIA = MAX;
export const voiceKey = (localId) => `${localId}:voice`;

const open = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB, 1);
  req.onupgradeneeded = () => req.result.createObjectStore(STORE);
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});
const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const r = fn(t.objectStore(STORE));
    t.oncomplete = () => { db.close(); resolve(r.result); };
    t.onerror = () => { db.close(); reject(t.error); };
  });
};

export const putPhoto = (id, blob) => tx("readwrite", (s) => s.put({ blob, name: blob.name || "photo.jpg", type: blob.type }, id));
export const putVoice = (localId, blob, mime) => tx("readwrite", (s) => s.put({ blob, name: `voice-note.${/mp4/.test(mime) ? "m4a" : /ogg/.test(mime) ? "ogg" : "webm"}`, type: mime }, voiceKey(localId)));
export const getPhoto = (id) => tx("readonly", (s) => s.get(id));
export const deletePhoto = (id) => tx("readwrite", (s) => s.delete(id));
export const deleteMedia = (localId) => Promise.all([deletePhoto(localId), deletePhoto(voiceKey(localId))]);
export const countPhotos = () => tx("readonly", (s) => s.count());
